import i18next, { i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { languages } from './i18n.constants';
import { en, es } from './18n.translations';

export const createI18n = (language: string): i18n => {
  const i18n = i18next.createInstance().use(initReactI18next);

  i18n.init({
    lng: language,
    fallbackLng: language,
    resources: {
      [languages.en]: en,
      [languages.es]: es,
    },
    keySeparator: '-',
  });

  return i18n;
};
